<template>
  <Modal ref="modal" class="SimpleModal">
    <div slot="title" class="title">
      <pre v-html="title"></pre>
    </div>
    <div slot="buttons">
      <button @click="click" style="flex-grow: 1;">확인</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modal/Modal'

export default {
  name: 'SimpleModal',
  components: {
    Modal,
  },
  props: ['title'],
  methods: {
    click() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.SimpleModal {
  .title {
    font-size: 18px;
    line-height: 1.67;
    text-align: center;
    color: #333333;
    pre {
      margin: 0;
      padding: 40px;
    }
  }
  .buttons {
    button {
      font-weight: 900;
      font-size: 20px;
      text-align: center;
      color: #ffffff;
      background-color: #333333;
    }
  }
}
</style>
